import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { LanguageService, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './language.service';

@Injectable({
    providedIn: 'root'
})
export class LanguageRouteGuard implements CanActivate {
    constructor(
        private languageService: LanguageService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree {
        const lang = route.params['lang'];

        // If valid language, set it and continue (don't navigate since we're already there)
        if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
            this.languageService.setLanguage(lang, false);
            return true;
        }

        // If no language in URL, redirect to default language
        const currentLang = this.languageService.getCurrentLanguage().code || DEFAULT_LANGUAGE;
        const pathWithoutLang = state.url === '/' ? '' : state.url;
        return this.router.createUrlTree([`/${currentLang}${pathWithoutLang}`]);
    }
}
